import React, {Component} from 'react'
import classNames from 'classnames'
import styled from 'styled-components'

class Button extends Component
	render: ()->
		isSecondary = !!@props.secondary
		
		<StyledButton className={classNames({_arrow:!isSecondary, _secondary:isSecondary})} onClick={@props.action}>
			{@props.label}
		</StyledButton>


StyledButton = styled.div"""
	display: inline-block;
	margin-top: 30px;
	background-color: #FAC507;
	padding: 17px 30px;
	border-radius: 5px;
	font-size: 15px;
	font-weight: 600;
	color: white;
	text-align: center;
	cursor: pointer;
	user-select: none;

	&._secondary {
		background-color: #bebebe;
		margin-right: 10px;
	}

	&._arrow:after {
		content: 'm';
		position: relative;
		top: 2px;
		margin-left: 7px;
		font-size: 14px;
		font-family: icons;
		line-height: 1;
		opacity: 0.5;
	}
"""


export default Button